/* eslint-disable no-useless-escape */
const getContentType = (element) =>
  element.match(/content-type=(?:\'.*?\'|\".*?\")/gi)[0].split(`"`)[1];

const getUrl = (element) =>
  element.match(/url=(?:\'.*?\'|\".*?\")/gi)[0].split(`"`)[1];

const getFileName = (element) =>
  element.match(/filename=(?:\'.*?\'|\".*?\")/gi)[0].split(`"`)[1];

const createYoutubeEmbed = (key) => {
  const youtubeIdReg = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
  const keyMatch = key.match(youtubeIdReg)[1];
  return `
  <div class="youtube-video" style="position: relative; background-color: #c6c6c6">
    <iframe style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;" src="https://www.youtube.com/embed/${keyMatch}" frameborder="0" allowfullscreen></iframe>
  </div>`;
};

const matchYoutube = (text) => {
  const youtubeReg = /(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([^& \n<]+)(?:[^ \n<]+)?/g;
  return text.match(youtubeReg);
};

const matchAnchor = (text) => {
  const youtubeReg = /<a[\s]+([^>]+)>((?:.(?!\<\/a\>))*.)<\/a>/g;
  return text.match(youtubeReg);
};

const getHref = (element) =>
  element.match(/url=(?:\'.*?\'|\".*?\")/gi)[0].split(`"`)[1];

const createImage = (key) =>
  `<img alt="recurso" src="${getUrl(key)}" className="m-5"></img>`;

// const createAnchor = (key) =>
//   `<a target="_blank" href="${getHref(key)}">${getHref(key)}</a>`;

const createLink = (key) =>
  `<a target="_blank" href="${getHref(key)}">${getFileName(key)}</a>`;

const transformHTML = (textHtml) => {
  let text = textHtml;
  if (!text) return text;
  const linkReg = /<a[\s]+([^>]+)>((?:.(?!\<\/a\>))*.)<\/a>/g;
  const actionTextReg = /<action-text-attachment( [^<>]+)?>(.?)<\/action-text-attachment>/g;

  Array.from(text.matchAll(linkReg)).forEach((e) => {
    if (matchYoutube(e[2])) {
      text = text.replace(e[0], createYoutubeEmbed(e[2]));
    }
    if (matchAnchor(e[0])) {
      text = text.replace(
        e[0],
        `${e[0].slice(0, 2)} target="_blank"${e[0].slice(2)}`
      );
    }
  });

  Array.from(text.matchAll(actionTextReg)).forEach((e) => {
    let contentType = getContentType(e[1]);
    contentType = contentType.includes('image') ? 'image' : contentType;
    switch (contentType) {
      case 'image':
        text = text.replace(e[0], createImage(e[1]));
        break;
      case 'application/pdf':
        text = text.replace(e[0], createLink(e[1]));
        break;
      default:
        text = text.replace(e[0], createLink(e[1]));
        break;
    }
  });
  return text;
};

export { getContentType, getUrl, getFileName, transformHTML };
